import styled, { css } from 'styled-components';
import { addStyleIfPropTruly } from "../../utils/styledComponents";
import Flex from "../Grid/Flex";
import colors from "../../colors";
export var CheckBoxContainer = styled.div.withConfig({
  displayName: "styled__CheckBoxContainer",
  componentId: "sc-171jwsc-0"
})(["position:relative;", ""], addStyleIfPropTruly('inline', 'display: inline-block'));
export var CheckboxLabel = styled.label.withConfig({
  displayName: "styled__CheckboxLabel",
  componentId: "sc-171jwsc-1"
})(["user-select:none;display:flex;align-items:center;cursor:pointer;"]);
export var CheckboxIcon = styled(Flex).attrs({
  center: true,
  middle: true
}).withConfig({
  displayName: "styled__CheckboxIcon",
  componentId: "sc-171jwsc-2"
})(["border-radius:2px;border-width:1px;border-style:solid;width:16px;height:16px;box-sizing:border-box;transition:border-color,filter,background-color 200ms ease;margin-right:8px;overflow:hidden;flex:0 0 16px;", ";"], function (_ref) {
  var isKomus = _ref.isKomus,
      checked = _ref.checked;

  if (isKomus && checked) {
    return css(["svg{& path{fill:", " !important;}}"], colors.primaryMain);
  }
});

var themedCheckBox = function themedCheckBox(bg, border, checkedBg, checkedBorder, icon) {
  return css(["& + ", " ", "{background-color:", ";border-color:", ";svg{transition:fill 200ms ease;fill:transparent;}}&:not(:checked):not(:disabled) + ", " ", "{&:hover{filter:brightness(0.97);}}&:focus:not(:checked):not(:disabled),&:active:not(:checked):not(:disabled){& + ", "{filter:brightness(0.97);}}&:checked{& + ", " ", "{border-color:", ";background-color:", ";svg{fill:", ";}}}&:disabled{& + ", " ", "{svg{fill:transparent;}}& + ", "{color:#ccc;}}&:disabled:not(:checked){& + ", " ", "{border-color:#ccc;}& + ", "{color:#ccc;}}&:disabled:checked{& + ", " ", "{svg{fill:#bbb;}}}"], CheckboxLabel, CheckboxIcon, bg, border, CheckboxLabel, CheckboxIcon, CheckboxLabel, CheckboxLabel, CheckboxIcon, checkedBorder, checkedBg, icon, CheckboxLabel, CheckboxIcon, CheckboxLabel, CheckboxLabel, CheckboxIcon, CheckboxLabel, CheckboxLabel, CheckboxIcon);
};

export var CheckboxInput = styled.input.withConfig({
  displayName: "styled__CheckboxInput",
  componentId: "sc-171jwsc-3"
})(["appearance:none;position:absolute;&:checked + ", ",&:disabled + ", "{cursor:default;}", ""], CheckboxLabel, CheckboxLabel, function (_ref2) {
  var theme = _ref2.theme;
  var _theme$checkBox = theme.checkBox,
      bg = _theme$checkBox.bg,
      border = _theme$checkBox.border,
      checkedBg = _theme$checkBox.checkedBg,
      checkedBorder = _theme$checkBox.checkedBorder,
      icon = _theme$checkBox.icon;
  return themedCheckBox(bg, border, checkedBg, checkedBorder, icon);
});